import { Component, OnInit } from '@angular/core';
import { DrawersService } from '../drawers.service';
import { tap } from 'rxjs';

@Component({
  selector: 'app-custom-drawer',
  templateUrl: './custom-drawer.component.html',
  styleUrls: ['./custom-drawer.component.scss']
})
export class CustomDrawerComponent implements OnInit {
  size = 30;
  readonly customDrawer$ = this._drawers.customDrawerChanged$.pipe(
    tap(x => this.size = x?.size ?? this.size)
  );
  constructor(private _drawers: DrawersService) { }

  ngOnInit() { }

  closeDrawer() {
    const drawer = this._drawers.getDrawer('custom-drawer');
    if (drawer) {
      drawer.close();
    }
  }
}
